var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterSource({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "469.5 271.5 21 17",
    style: {
      enableBackground: "new 469.5 271.5 21 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9ACEE9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.4,273.6c-0.8,0.3-1.6,0.6-2.5,0.7c0.9-0.5,1.6-1.4,1.9-2.4c-0.8,0.5-1.7,0.8-2.7,1 c-0.8-0.8-1.9-1.3-3.1-1.3c-2.4,0-4.3,1.9-4.3,4.2c0,0.3,0,0.7,0.1,1c-3.6-0.2-6.7-1.9-8.8-4.4c-0.4,0.6-0.6,1.4-0.6,2.1 c0,1.5,0.8,2.8,1.9,3.5c-0.7,0-1.4-0.2-1.9-0.5v0.1c0,2.1,1.5,3.8,3.4,4.2c-0.4,0.1-0.7,0.1-1.1,0.1c-0.3,0-0.5,0-0.8-0.1 c0.5,1.7,2.1,2.9,4,2.9c-1.5,1.1-3.3,1.8-5.3,1.8c-0.3,0-0.7,0-1-0.1c1.9,1.2,4.1,1.9,6.5,1.9c7.8,0,12.1-6.5,12.1-12.1v-0.6 C489.1,275.2,489.8,274.4,490.4,273.6L490.4,273.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSource);
export default __webpack_public_path__ + "static/media/twitter_source.68eb9e40d2b0eac1897fe01ad0194f32.svg";
export { ForwardRef as ReactComponent };